type Callback<T> = (args: T) => void;

export const promisify =
  <T, U>(fn: (args: T, cb: Callback<U>) => void): ((args: T) => Promise<U>) =>
  (args: T) =>
    new Promise((resolve) => {
      fn(args, (callbackArgs) => {
        resolve(callbackArgs);
      });
    });
